import axios from 'axios'
import get from 'lodash/get'

// Libs
import { thunkHandler, thunkErrorHanlder } from '../../libs/utils'

// Constants
import { GET_TEAM_NOTIFICATIONS, UPDATE_TEAM_NOTIFICATIONS } from '../../constants/endpoints'

export const NEW_NOTIFICATIONS = 'NEW_NOTIFICATIONS'
export const SHOW_MODAL = 'SHOW_MODAL'

export function getNotifications() {
  return dispatch => axios.get(GET_TEAM_NOTIFICATIONS)
    .then(res => {
      return thunkHandler(dispatch, get(res, 'data.data'), NEW_NOTIFICATIONS, 'ERROR')
    })
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getNotifications

export function updateNotifications(body) {
  return dispatch => axios.put(UPDATE_TEAM_NOTIFICATIONS, body)
    .then(() => axios.get(GET_TEAM_NOTIFICATIONS))
    .then(res => {
      thunkHandler(dispatch, get(res, 'data.data'), NEW_NOTIFICATIONS, 'ERROR')
    })
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END updateNotifications

export function addPusherNotification(notifications) {
  return dispatch => Promise.resolve(dispatch({
    type: NEW_NOTIFICATIONS,
    payload:notifications

  }));
} // END updateNotifications

export function toggleModal(value) {
  return dispatch => Promise.resolve(dispatch({
    type: SHOW_MODAL,
    payload: { modal: value }

  }));

} // onChangeIsLoadingButton



// WEBPACK FOOTER //
// ./src/redux/actions/topbarNotificationsActions.js